export const isZeroOrLess = (value: number, precision: number = 2): boolean => {
  if (value < 0) {
    return true;
  }

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });

  if (precision === 0) {
    return formatter.format(value) === '0';
  }

  return formatter.format(value) === ['0', ''.padEnd(precision, '0')].join('.');
};
